/* Polarno odmotavanje listića: kolone = vreme (0 = ponoć, levo na listiću, u smeru kazaljke),
   redovi = poluprečnik kao deo R. Uzorkovanje je bilinearno, vrednost je osvetljenost 0..255. */

export const MIN_DAY = 1440;

export function lumAt(img, x, y) {
    const { width: W, height: H, data } = img;
    if (x < 0 || y < 0 || x >= W - 1 || y >= H - 1) return 255;
    const x0 = Math.floor(x), y0 = Math.floor(y), fx = x - x0, fy = y - y0;
    const l = (xx, yy) => {
        const i = (yy * W + xx) * 4;
        return (data[i] + data[i + 1] + data[i + 2]) / 3;
    };
    return (l(x0, y0) * (1 - fx) + l(x0 + 1, y0) * fx) * (1 - fy) + (l(x0, y0 + 1) * (1 - fx) + l(x0 + 1, y0 + 1) * fx) * fy;
}

/** ugao na slici (radijani) za vreme u minutima i rotaciju listića u minutima */
export const angleOf = (minute, rotMin = 0) => -Math.PI + ((minute + rotMin) * 2 * Math.PI) / MIN_DAY;

/**
 * Odmotava prsten [r0, r1] (deo R) u Float32Array (rows x cols), red 0 = spoljni (r1).
 * cols = broj kolona po krugu (perMin = cols / 1440).
 */
export function unwrap(img, disc, { r0, r1, rows, cols = MIN_DAY, rotMin = 0 }) {
    const out = new Float32Array(rows * cols);
    for (let y = 0; y < rows; y++) {
        const rr = (r1 - ((r1 - r0) * y) / (rows - 1)) * disc.r;
        for (let x = 0; x < cols; x++) {
            const a = angleOf((x * MIN_DAY) / cols, rotMin);
            out[y * cols + x] = lumAt(img, disc.cx + rr * Math.cos(a), disc.cy + rr * Math.sin(a));
        }
    }
    return { data: out, rows, cols, r0, r1 };
}
